module.exports = __webpack_public_path__ + "img/baleno-gls.da29ec1a.png";